(function () {
    angular.module('tmx-app').controller('leadsEditCtrl', ['$state', '$filter', '$mdDialog', 'tmxUtility', 'resolvedData', 'LoanProductService', 'TMX_FINANCE_CONSTANTS','LeadService','ToastService',
        function LeadsEditCtrl($state, $filter, $mdDialog, tmxUtility, resolvedData, LoanProductService, TMX_FINANCE_CONSTANTS,LeadService,ToastService) {
            var leadsVM = this;
            leadsVM.vm = {};
            leadsVM.LeadGeneratorLookups = [];
            leadsVM.LeadTypeLookups = [];
            leadsVM.ConvertedLookups = [];
            leadsVM.MappingProductList = [];
            var leadDetailCoreFields = ['LeadDetailId', 'Name', 'FatherName', 'MotherName', 'LastName', 'NationalIdType', 'NationalIdValue', 'DateOfBirth'];
            var dynamicFields = [];
            var leadTypeLkp = null;

            //#region ----------------Private Functions ---------------------------------
            function HandleResolveData() {
                if (tmxUtility.exists(resolvedData.LeadData, 'data')) {
                    leadsVM.vm = resolvedData.LeadData.data;
                    leadTypeLkp = leadsVM.vm.LeadTypeLkp;
                    leadsVM.readonly = leadsVM.vm.IsConverted == '1' || leadsVM.vm.IsConverted == true;
                    if (tmxUtility.exists(leadsVM.vm.TmxLeadDetail)) {
                        Object.keys(leadsVM.vm.TmxLeadDetail).forEach(key => {
                            if (!leadDetailCoreFields.includes(key)) {
                                dynamicFields.push({ FieldName: key, Value: leadsVM.vm.TmxLeadDetail[key] });
                            }
                        });

                    }
                }
                if (tmxUtility.exists(resolvedData.LeadGeneratorLookup)) {
                    leadsVM.LeadGeneratorLookups = resolvedData.LeadGeneratorLookup;
                }
                if (tmxUtility.exists(resolvedData.LeadTypeLookup)) {
                    leadsVM.LeadTypeLookups = resolvedData.LeadTypeLookup;
                }
                leadsVM.ConvertedLookups = [{ HiddenValue: '0', VisibleValue: 'No' }, { HiddenValue: '1', VisibleValue: 'Yes' }];
            }
            function makeTable(colsize, array) {
                var table = [];
                var row = [];
                for (var i = 0; i < array.length; i++) {
                    if (row.length < colsize) {
                        row.push(array[i]);
                    }
                    else {
                        table.push(row);
                        row = [array[i]];
                    }
                }
                if (row.length > 0) {
                    table.push(fillToFit(row, colsize));
                }
                return table;
            }
            function fillToFit(row, colsize) {
                while (row.length !== colsize) {
                    row.push({
                        type: "dummy"
                    });
                }
                return row;
            }

            function CreateUdfFields() {
                leadsVM.table = [];
                var noOfColumns = 5;
                if (tmxUtility.getScreenWidthCode() == 'sm' || tmxUtility.getScreenWidthCode == 'xs') {
                    noOfColumns = 3;
                }
                if (dynamicFields != null && dynamicFields.length > 0) {
                    leadsVM.table = makeTable(noOfColumns, dynamicFields)
                }
            }
            function FilterProductsForLead(productTypes) {
                if (leadTypeLkp == null) return null;
                var leadTypeHiddenValue = leadsVM.LeadTypeLookups.find(x => x.LookupId == leadTypeLkp).HiddenValue;
                if (leadTypeHiddenValue) {
                    if (leadTypeHiddenValue.toLowerCase() == TMX_FINANCE_CONSTANTS.LOOKUP_HV.AccountLead) {
                        return productTypes.filter(x => x.HiddenValue == TMX_FINANCE_CONSTANTS.LOOKUP_HV.AccountProduct)
                    }
                    else if (leadTypeHiddenValue.toLowerCase() == TMX_FINANCE_CONSTANTS.LOOKUP_HV.LoanLead) {
                        return productTypes.filter(x => x.HiddenValue == TMX_FINANCE_CONSTANTS.LOOKUP_HV.LoanProduct)
                    }
                }
                return null;
            }
            function GetAvailableProductsInBackground() {
                var allProductTypes = LoanProductService.productTypes;
                var mappingApplicationProductTypes = FilterProductsForLead(allProductTypes);
                if (mappingApplicationProductTypes != null) {
                    var productTypeLookupIds = mappingApplicationProductTypes.map(x => x.LookupId);
                    LoanProductService.getAllLoanProducts().then(function (response) {
                        response.data.forEach(product => {
                            if (productTypeLookupIds.includes(product.ProductTypeLkp)) {
                                leadsVM.MappingProductList.push(product);
                            }

                        })
                    });
                }
            }

            //#endregion


            //#region =--------------------- Scope Functions -----------------------------------

            leadsVM.ClickCancel = function () {
                $state.searchClear = true;
                $state.go("^", {}, { reload: true });
            };

            leadsVM.ClickConvert = function () {
                var metaDataLovs = {};
                metaDataLovs.ProductList = leadsVM.MappingProductList;
                $mdDialog.show({
                    controller: ['$scope', '$mdDialog', 'tmxUtility', 'data', 'lovs', 'ToastService', leadConvertDialogController],
                    locals: {
                        data: leadsVM.vm,
                        lovs: metaDataLovs
                    },
                    templateUrl: 'app/private/leads/edit/lead-convert-dialog.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    fullscreen: true
                }).then(function (returnData) { // After closing the dialog
                    if (!tmxUtility.exists(returnData)) {
                        return;
                    }
                    let postData = leadsVM.vm;
                    postData.ProductId = returnData.selectedProduct;
                    LeadService.ConvertLeadToApplication(postData).then(function(result){
                        if(result.data && (result.status.code == "201") ){
                            ToastService.showCustomToast("success", result.status.message);
                            $state.searchClear = true;
                            $state.go("^");
                            return;
                        }
                        ToastService.showCustomToast("error", $filter('translate')("ActionNotPerformed"));
                    });
                });
            };


            //#endregion

            //#region ========= Child Controllers ================================

            function leadConvertDialogController($scope, $mdDialog, tmxUtility, data, lovs, ToastService) {
                $scope.readonly = false;
                $scope.productListLookup = [];

                (function InitializeDataForDialog() {
                    if(tmxUtility.exists(lovs,'ProductList')){
                        $scope.productListLookup = lovs.ProductList.map(x=> ({HiddenValue:x.ProductId,VisibleValue:x.ProductName}));
                    }
                })();


                $scope.cancel = function () {
                    $mdDialog.hide();
                }

                $scope.ok = function () {
                    $scope.leadDetailsCtrl.dialogForm.$submitted = true;
                    if (!$scope.leadDetailsCtrl.dialogForm.$valid) {
                        ToastService.showCustomToast("error", $filter('translate')("FillRequiredFields"));
                        return;
                    }
                    let returnData = {
                        selectedProduct:$scope.SelectedProduct,
                    }
                    $mdDialog.hide(returnData);
                }

            }

            //#endregion

            (function InitializePage() {
                HandleResolveData();
                CreateUdfFields();
                GetAvailableProductsInBackground();
            })();
        }]);
})();
